var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#01104B;}")),React.createElement("path",{"d":"M5.977,19.477H24.2l-8.4,8.4,2.175,2.1,12-12-12-12-2.1,2.1,8.325,8.4H5.977Z","transform":"translate(-5.977 -5.977)","key":1})]);
}

RightArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
